import { Dialog } from "@headlessui/react"
import { FC, PropsWithChildren } from "react"

export const DialogTitle: FC<PropsWithChildren<{}>> = ({ children }) => {
  return (
    <Dialog.Title as="h3" className="text-xl text-white pl-1">
      {children}
    </Dialog.Title>
  )
}

export const DialogSubtitle: FC<PropsWithChildren<{}>> = ({ children }) => {
  return (
    <div className="mt-2 pl-1">
      <p className="text-sm text-white whitespace-pre-line">{children}</p>
    </div>
  )
}
